import { IUserAddress } from './user-address';

export enum UserPhoneTypeTitle {
    phone_home = 'Home',
    phone_cell = 'Cell',
    phone_fax = 'Fax',
    phone_business = 'Business',
    phone_business_fax = 'Business Fax',
    phone_other = 'Other',
}

export interface IUserPhone {
    id?: number;
    isPrimaryPhone: number;
    phone: string;
    phoneType: string;
    user?: number;
}

export class UserPhone implements IUserPhone {
    id?: number;
    isPrimaryPhone = 0;
    phone = '';
    phoneType = 'phone_home';

    constructor(phone: Partial<IUserPhone> = {}) {
        Object.assign(this, phone);
    }
}



// WEBPACK FOOTER //
// /app/src/app/types/api-response/building/user-phone.ts